module.exports = __webpack_public_path__ + "img/my_profile.97ca136d.svg";